module.exports = __webpack_public_path__ + "static/media/share-screen.9af01906.svg";